import { render, staticRenderFns } from "./InstallationQuestionTemplates.vue?vue&type=template&id=518a5052&"
import script from "./InstallationQuestionTemplates.vue?vue&type=script&lang=js&"
export * from "./InstallationQuestionTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports